<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <button class="close-button" (click)="onClose()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#101223" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Image -->
    <div class="modal-image">
      <div class="illustration">
        <!-- Success illustration - using a simple checkmark icon for now -->
       <img src="assets/images/table/Illustrations.svg" alt="Success Illustration">
      </div>
    </div>

    <!-- Text Content -->
    <div class="modal-text">
      <h2 class="modal-title">Appointment Canceled!</h2>
      <p class="modal-description">
        This appointment has been cancelled and removed from your calendar. Do you want to create another one?
      </p>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="button-container">
        <button class="btn btn-secondary" (click)="onOkay()">
          Okay
        </button>
        <button class="btn btn-primary" (click)="onCreateAnother()">
          Create Another
        </button>
      </div>
    </div>
  </div>
</div>
